<script>
  export let team;
  export let lang = undefined;
</script>

<div class='game-score-team'>
  <img class='game-score-team-flag' src='img/static/flag/{team.flag}.svg' alt='{team.name.en} flag'/>

  <a href='./#/teams/{team.code}' class='game-score-team-label'> {team.name[lang]} </a>
  <a href='./#/teams/{team.code}' class='game-score-team-shortcut'> {team.shortcut.toUpperCase()} </a>
</div>

<style>
  .game-score-team {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;

    width: 150px;
    height: 20px;

    font-weight: 550;
  }

  .game-score-team-label {
    text-align: left;
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: inherit;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .game-score-team-shortcut {
    display: none;
    justify-content: center;

    width: 100%;

    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    color: inherit;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .game-score-team-label:hover, .game-score-team-shortcut:hover {
    text-decoration-color: var(--black);
  }

  .game-score-team-flag {
    height: 20px;

    border-radius: var(--radius-sm);
  }

  :global(body.dark) .game-score-team-label:hover, :global(body.dark) .game-score-team-shortcut:hover {
    text-decoration-color: var(--grey-3);
  }

  :global(body.dark) .game-score-team-flag {
    filter: brightness(88%);
  }

  @media only screen and (max-width: 450px) {
    .game-score-team {
      width: 75px;
    }

    .game-score-team-label {
      display: none;
    }

    .game-score-team-shortcut {
      display: flex;
    }
  }
</style>
